<template>
  <div v-if="hasParams">
    <div v-if="isDebug" class="debug_str">WT-1 本テスト 検査１ p13</div>

    <!-- ↓ p13 は単独 --><!-- 練習１ 検査１ p08 へ流用 -->

    <div class="row">
      <div class="col-12 px-3">
        <MyTextBox class="" :canEdit="canEdit" v-model="params.s01" />
        <MyTextBox class="my-3" :isTextarea="true" :canEdit="canEdit" v-model="params.s02" />
        <MyTextBox class="text-right small" :canEdit="canEdit" v-model="params.s03" />
      </div>
    </div><!-- row -->

    <div :class="`row ${questionIds[0]}`"><!-- q026 -->

      <div class="col-12 mt-3 px-3">
        <div class="question_table_wrapper">
          <div class="question_table">
            <div class="question_table_row">
              <div class="question_no">{{ params[questionIds[0]].q_no }}</div>
              <MyTextBox class="question_str_90" :canEdit="canEdit" v-model="params[questionIds[0]].question" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 px-3">
        <div class="text_container ml-md-5 bg-lightyellow">
          <MyTextBox class="" :isTextarea="true" :canEdit="canEdit" v-model="params[questionIds[0]].s01" />
        </div>
      </div>

      <div class="col-12 col-md-6 offset-md-6 px-3 px-md-0">
        <div class="checkbox_table_wrapper">
          <table class="checkbox_table">
            <tr>
              <td v-for="choiceValue in choiceValues[0]" :key="choiceValue"><div class="choice_value">{{ choiceValue }}</div></td>
            </tr>
            <tr>
              <td v-for="choiceValue in choiceValues[0]" :key="choiceValue">
                <input type="checkbox" :id="`${questionIds[0]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                        v-model="params[questionIds[0]].answer"
                        :ref="`checkbox_q${questionIds[0]}`"
                        @click="onClickCheckbox(params[questionIds[0]], $refs[`checkbox_q${questionIds[0]}`], $event)"
                        @change="sortCheckboxAnswers(params[questionIds[0]])"
                />
                <label :for="`${questionIds[0]}_${choiceValue}`" class="choice_checkbox_placeholder"></label>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div><!-- row -->

    <div :class="`row ${questionIds[1]}`"><!-- q027 -->

      <div class="col-12 px-3">
        <div class="question_table_wrapper">
          <div class="question_table">
            <div class="question_table_row">
              <div class="question_no">{{ params[questionIds[1]].q_no }}</div>
              <MyTextBox class="question_str_90" :canEdit="canEdit" v-model="params[questionIds[1]].question" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 offset-md-6 px-3 px-md-0">
        <div class="textbox_table_wrapper">
          <div class="textbox_table">
            <div class="textbox_table_row">
              <input type="text" class="answer_textbox" :disabled="!canAnswer" v-model="params[questionIds[1]].answer[0]"
                      :maxLength="AnsMaxLen_本テスト"
                      @change="onChangeTextbox"
              />
            </div>
          </div>
        </div>
      </div>

    </div><!-- row -->

    <div :class="`row ${questionIds[2]}`"><!-- q028 -->

      <div class="col-12 px-3">
        <div class="question_table_wrapper">
          <div class="question_table">
            <div class="question_table_row">
              <div class="question_no">{{ params[questionIds[2]].q_no }}</div>
              <MyTextBox class="question_str_90" :canEdit="canEdit" v-model="params[questionIds[2]].question" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 px-3">
        <MyTextBox class="ml-md-5" :isTextarea="true" :canEdit="canEdit" v-model="params[questionIds[2]].s01" />
      </div>

      <div class="col-12 col-md-6 px-3">
        <div class="choice_table_wrapper ml-md-5">
          <div class="choice_table bg-lightyellow">
            <div class="choice_table_row" v-for="(choiceValue, choiceIdx) in choiceValues[0]" :key="choiceValue">
              <div class="choice_value text-red right_margin">{{ choiceValue }}</div>
              <MyTextBox class="choice_caption" :canEdit="canEdit" v-model="params[questionIds[2]].choices[choiceIdx]" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="checkbox_table_wrapper">
          <table class="checkbox_table">
            <tr>
              <td v-for="choiceValue in choiceValues[0]" :key="choiceValue"><div class="choice_value">{{ choiceValue }}</div></td>
            </tr>
            <tr>
              <td v-for="choiceValue in choiceValues[0]" :key="choiceValue">
                <input type="checkbox" :id="`${questionIds[2]}_${choiceValue}`" class="choice_checkbox" :value="choiceValue" :disabled="!canAnswer"
                        v-model="params[questionIds[2]].answer"
                        :ref="`checkbox_q${questionIds[2]}`"
                        @click="onClickCheckbox(params[questionIds[2]], $refs[`checkbox_q${questionIds[2]}`], $event)"
                        @change="sortCheckboxAnswers(params[questionIds[2]])"
                />
                <label :for="`${questionIds[2]}_${choiceValue}`" class="choice_checkbox_placeholder"></label>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div><!-- row -->

    <!-- ↑ p13 は単独 -->

    <div v-if="showDescription" class="my-3">
      <hr />
      <div class="description_area_title my-2">【解説】</div>

      <div class="description_tables_wrapper">
        <DescriptionTable :class="questionId" v-for="questionId in questionIds" :key="questionId">
          <template v-slot:q_no>{{ params[questionId].q_no }}</template>
          <template v-slot:answer>正解：{{ getDescAnswerStr(params[questionId]) }}</template>
          <template v-slot:description>
            <MyTextBox :isTextarea="true" :canEdit="canEdit" v-model="params[questionId].description" />
          </template>
        </DescriptionTable>
      </div>

    </div>

  </div>
</template>

<script>
import commonMixin from '../../../common_page';
const LogHeader = 'WT-1/本テスト/検査１/p13';

export default {
  mixins: [
    commonMixin,
  ],
  data() {
    //console.log(`[${LogHeader}] data() CALLED`);
    return {
      questionIds: [ 'q026', 'q027', 'q028' ],
      choiceValues: [
        [ 'A', 'B', 'C', 'D' ],
      ],
    };
  },
  // created() {
  //   console.log(`[${LogHeader}] created() CALLED`);
  // },
  // mounted() {
  //   console.log(`[${LogHeader}] mounted() CALLED`);
  // },
  activated() {
    console.log(`[${LogHeader}] activated() CALLED`);
  },
  deactivated() {
    console.log(`[${LogHeader}] deactivated() CALLED`);
  },
  methods: {
  },
};
</script>

<style lang="sass" scoped>
.q027
  .answer_textbox
    width: 8em
</style>
